export const DOMAIN = "developer.dida365.com";
